import { api } from '@general/ui-kit'

// Thin wrapper over platform/demo/backend. Views never build URLs themselves.
export const demoApi = {
  // Open: it is the modules' own marketing copy, on an instance whose whole
  // database is invented. On a real instance this answers 404, which is what
  // `isDemoInstance()` in session.js reads.
  catalogue: () => api.get('/demo/catalogue'),

  // No credentials. The session that comes back holds the read half of these
  // modules and nothing else.
  openSession: (modules) => api.post('/demo/session', modules ? { modules } : {}),

  // The one-use code from the front page, traded for a visit of fixed length.
  redeem: (ticket) => api.post('/demo/redeem', { ticket }),

  // `crm:open`, as the IACL panel counts it. Never awaited by anybody: a lost
  // event is a lost number, never a broken screen.
  track: (event, module) => api.post('/demo/track', module ? { event, module } : { event }),
}

export default demoApi
